/**
 * created by wang lei
首行缩进页面
 *
 */
import React, {Component} from 'react';
import rowHeightIndent from './rowHeightIndent.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class RowHeightIndentTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowHeightIndent:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let rowHeightIndent = this.props.editor.queryCommandState("indent");
        this.setState({rowHeightIndent: rowHeightIndent === 1});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let rowHeightIndent = this.props.editor.queryCommandState("indent");
        this.setState({rowHeightIndent: rowHeightIndent === 1});
    }
    render() {
        let style = {};
        if(this.state.rowHeightIndent){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'indent' );
                this.setState({rowHeightIndent: !this.state.rowHeightIndent});
            }}>
                <img className={"editor-indent-tool-btn"} style={style} src={rowHeightIndent}/>
                <style>{`
                .editor-indent-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-indent-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-indent-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        )
    }

}